"use client";
import React, { useState } from "react";

import styles from "./LeadTheFutureCareer.module.scss"
import MidLine from "@/SvgIcons/MidLine";
import LeadTheFutureDownArrow from "@/SvgIcons/LeadTheFutureDownArrow";
import clsx from "clsx";


interface LeadTheFutureProps {
  LeadTheFutureComponent?: any;
  hideSubheading?: boolean;
  hideArrow?: boolean;
  hideMwebAccordion?: boolean;
  hideRightImage?: boolean;
  isCustomData?: boolean;
}

export default function LeadTheFutureCareer({
  LeadTheFutureComponent,
  hideSubheading = false,
  hideArrow = false,
  hideMwebAccordion = false,
  hideRightImage = false,
  isCustomData = false,
}: LeadTheFutureProps) {

  const dataToUse = LeadTheFutureComponent;
  if(!dataToUse)return null

  const [currentSelectedState, setCurrentSelectedState] = useState(dataToUse?.List?.[0]?.Heading);
  const [currentSelectedStateIndex, setCurrentSelectedStateIndex] = useState(0);

  const isMobile = () => {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  };


  const onClickHandler = (key, index) => {
    if (key === currentSelectedState && isMobile()) {
      setCurrentSelectedState("");
      setCurrentSelectedStateIndex(0);
    } else {
      setCurrentSelectedState(key);
      setCurrentSelectedStateIndex(index);
    }
  };

  const formatText = (text) => {
    const match = text.match(/^(\d+)(.*)/);
    if (!match) return <>{text}</>;
    

    return (
      <>
        <span className="lining-nums">{match[1]}</span>
        {match[2]}
      </>
    );
  };
  const currentItem = dataToUse?.List?.[currentSelectedStateIndex];

  return (
    <div className={clsx(styles.leadTheFutureContainer, isCustomData && styles.customBackground)} id="program_overview">
      <div className={clsx(styles.leadTheFutureContainerInner, isCustomData && styles.customContainerInner, "lining-nums")}>
        <h2 className={clsx(styles.headingTitle, isCustomData && styles.customHeading)}>{dataToUse?.Heading}</h2>
        <p className={clsx(styles.headingSubTitle, isCustomData && styles.customSubHeading)}>{dataToUse?.Subheading}</p>

        <div className={clsx(styles.dropdownHeadVertical, isCustomData && styles.customWhiteBg)}>
          <div className={styles.headingWrapper}>
            {dataToUse?.List?.map(({ Heading, HeadingImage, RightImage, information }, index) => (
              <React.Fragment key={Heading}>
                <div
                  key={Heading}
                  className={
                    currentSelectedState != Heading
                      ? styles.headingWrapperInner
                      : `${styles.headingWrapperInner} ${styles.headingWrapperInnerSelected}`
                  }
                >
                  <div
                    onClick={() => onClickHandler(Heading, index)}
                    key={Heading}
                    className={currentSelectedState == Heading ? styles.heading : styles.headingSelected}
                  >
                    <div className={styles.logoHeadingContainer}>
                      <img src={
                            isCustomData
                              ? `${HeadingImage?.data?.attributes?.url}`
                              : HeadingImage?.data?.attributes?.url
                          } alt="Amity Online" /> {formatText(Heading)}
                    </div>
                    <div
                      className={
                        currentSelectedState != Heading
                          ? styles.leadTheFutureDownArrowDown
                          : styles.leadTheFutureDownArrowDownInitital
                      }
                    >
                      <LeadTheFutureDownArrow
                        color={currentSelectedState == Heading ? "#fff" : "#1a325d"}
                      />{" "}
                    </div>
                  </div>
                  {currentSelectedState == Heading && (
                    <div className={styles.mWebContent}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: information || "",
                          }}
                        />
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>

          <div className={styles.midline}>
            <MidLine />
          </div>

          <div className={styles.rightContent}>
              <div
                dangerouslySetInnerHTML={{  __html: currentItem?.information || "",
                }}
              />
          </div>

          {!hideRightImage && (
            <div className={styles.imageEnd}>
              <img src={dataToUse.List[currentSelectedStateIndex].RightImage?.data?.attributes?.url} alt="Amity Online" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
